<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import tatApiSvc from "@/services/tat-api";
import { toast } from "vue3-toastify";
import { DateTime } from "luxon";

export default {
  page: {
    title: "Manage Event",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Manage TAT",
      role:
        localStorage.getItem("userInfo") !== null
          ? JSON.parse(localStorage.getItem("userInfo")).role
          : "user",
      items: [
        {
          text: "Third Party",
          href: "list",
        },
        {
          text: "Manage TAT",
          active: true,
        },
      ],
      isDisabled: true,
      tatData: {
        thaiFestUuid: "",
        slug: "",
        name: "",
        nameEn: "",
        tatEventTypeName: "",
        description: "",
        descriptionEn: "",
        region: "",
        province: "",
        phone: "",
        thumbImage: "",
        startDate: "",
        endDate: "",
        dateCreated: "",
        dateUpdated: "",
      },
      cloneAlready: false,
    };
  },
  mounted() {
    this.get(this.$route.query.uuid);
  },
  methods: {
    get(uuid) {
      const page = 1;
      const perPage = 1;
      tatApiSvc
        .getAllTatic(page, perPage, uuid)
        .then((resp) => {
          if (resp?.data?.data?.data?.length) {
            this.tatData = resp.data.data.data[0];

            this.tatData.thaiFestUuid = this.tatData.cloneUUID;
          this.cloneAlready = this.tatData.isClone;

            this.tatData.phone = this.tatData.phone || "";

            // this.tatData.startDate = this.tatData.startDate
            //   ? DateTime.fromFormat(
            //       this.tatData.startDate,
            //       "dd-LLL-yy"
            //     ).toFormat("yyyy-MM-dd")
            //   : "";
            // this.tatData.endDate = this.tatData.endDate
            //   ? DateTime.fromFormat(this.tatData.endDate, "dd-LLL-yy").toFormat(
            //       "yyyy-MM-dd"
            //     )
            //   : "";
            this.tatData.dateCreated = this.tatData.dateCreated
              ? DateTime.fromISO(this.tatData.dateCreated).toFormat(
                  "yyyy-MM-dd"
                )
              : "";
            this.tatData.dateUpdated = this.tatData.dateUpdated
              ? DateTime.fromISO(this.tatData.dateUpdated).toFormat(
                  "yyyy-MM-dd"
                )
              : "";
          } else {
            toast.error("data not found", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
            this.$router.push("list");
          }
        })

        .catch((err) => {
          console.log(">>>", err);
          toast.error("data not found", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          this.$router.push("list");
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <form class="needs-validation">
            <div class="row">
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Event (Slug)</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.slug"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Category</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.tatEventTypeName"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Start Date</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.startDate"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">End Date</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.endDate"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3 position-relative">
                          <label for="">Name (TH)</label>
                          <input
                            :disabled="isDisabled"
                            v-model="tatData.name"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="mb-3 position-relative">
                          <label for="">Detail (TH)</label>
                          <textarea
                            :disabled="isDisabled"
                            v-model="tatData.description"
                            class="form-control"
                            id="exampleFormControlTextarea1"
                            rows="15"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3 position-relative">
                          <label for="">Name (EN)</label>
                          <input
                            :disabled="isDisabled"
                            v-model="tatData.nameEn"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="mb-3 position-relative">
                          <label for="">Detail (EN)</label>
                          <textarea
                            :disabled="isDisabled"
                            v-model="tatData.descriptionEn"
                            class="form-control"
                            id="exampleFormControlTextarea1"
                            rows="15"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Region</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.region"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Province</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.province"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Phone</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.phone"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Created At</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.dateCreated"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Updated At</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.dateUpdated"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Thumbnail</label>
                  <div v-if="tatData.thumbImage" class="tat-thumbnail">
                    <img alt="thumbnail" :src="tatData.thumbImage" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-sm-end">
              <b-button
                v-if="cloneAlready"
                router-link
                :to="`../event/manage?uuid=${tatData.thaiFestUuid}`"
                class="btn btn-warning ms-1"
                ro
              >
                View Duplicate
              </b-button>
              <b-button
                v-else
                router-link
                :to="`../event/manage?ref=${tatData.slug}`"
                class="btn btn-success ms-1"
              >
                Clone Data
              </b-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.form-control[type="text"],
.form-control[type="number"],
.form-control[type="date"] {
  height: 40px !important;
}

.tat-thumbnail img {
  width: 400px !important;
}
</style>
